export { default as useTeamShowPage } from './useTeamShowPage';
